"use client";
import { jsx } from "react/jsx-runtime";
import { useAnalyticObserverRef } from "../../../../utils/observable/utils.js";
import { getLinkBehavior } from "../../../../utils/targetLinkBehavior/getLinkBehavior.js";
import { useCallback } from "react";
import { useTracking } from "react-tracking";
import { AnnouncementBanner } from "@nxt-costco-com/forge-components";
import { Analytics } from "../../../Analytics/index.js";
import { TRACK_TYPE_VIEW } from "../../../Analytics/constants.js";
const ClientSideAnnouncementBanner = ({
  entry,
  analyticsTitlePrefix,
  enableOnViewTracking
}) => {
  var _a, _b, _c;
  let analyticsTitle = entry.title;
  if (analyticsTitlePrefix) {
    analyticsTitle = `${analyticsTitlePrefix} | ${analyticsTitle}`;
  }
  const { trackEvent } = useTracking();
  const analyticsData = {
    adItem: {
      isExternal: (_a = entry == null ? void 0 : entry.announcement_costco_url) == null ? void 0 : _a.external_site,
      title: (_b = entry == null ? void 0 : entry.announcement_costco_url) == null ? void 0 : _b.title,
      type: "ad",
      url: (_c = entry == null ? void 0 : entry.announcement_costco_url) == null ? void 0 : _c.url
    },
    itemCuration: "costco",
    title: analyticsTitle,
    trackType: "ad"
  };
  const onViewAnalyticHandler = useCallback(() => {
    trackEvent({ contentImp: analyticsTitle, trackType: TRACK_TYPE_VIEW });
  }, [trackEvent, analyticsTitle]);
  const observableRef = useAnalyticObserverRef({
    onView: onViewAnalyticHandler,
    enabled: !!enableOnViewTracking
  });
  const { external_site, same_tab_domain } = (entry == null ? void 0 : entry.announcement_costco_url) || {};
  const { target } = getLinkBehavior(external_site, same_tab_domain);
  return /* @__PURE__ */ jsx(Analytics, { analyticData: analyticsData, children: /* @__PURE__ */ jsx(
    AnnouncementBanner,
    {
      ref: observableRef,
      color: entry.select,
      href: entry.announcement_costco_url.url,
      text: entry.notification_message,
      target
    }
  ) });
};
export {
  ClientSideAnnouncementBanner
};
